import h, { FunctionComponent } from 'preact';
import capitalize from 'lodash/capitalize';
import debounce from 'lodash/debounce';
import classNames from 'classnames';
import MessageIcon from '../common/MessageIcon';
import Currency from '../common/Currency';

const BasketTableRow: FunctionComponent<BasketTableRowProps> = ({ sku, productName, url, size, colour, unitPrice, tax, subtotal, quantity, error, warning, multiple, isProcessing, onUpdateQuantity, onRemove }) => {
    return <tr class="basket__row t__basket-item text-blue js-basket-item">
        <td class="js-basket-title-cell basket__item border-left border-bottom border-top border-2 border-lg-top-0">
            {(error !== null || warning !== null) ? <MessageIcon type={(error !== null) ? 'error' : 'warning'} message={(error !== null) ? error : warning + ''} /> : null}
            <a class="js-basket-item-title font-weight-bold" href={url}>
                {productName}
            </a>
        </td>
        <td class="basket__size border-bottom text-nowrap">
            <span class="d-lg-none font-weight-bold">Size: </span>
            {size}
        </td>
        <td class="basket__variant border-bottom">
            <span class="d-lg-none font-weight-bold">Colour: </span>
            {capitalize(colour.replace('_', ' '))}
        </td>
        <td class="basket__unitprice border-bottom">
            <Currency amount={unitPrice} />
        </td>
        <td class={classNames('basket__quantity', 'border-bottom', { 'border-left': false, 'border-right': false })}>
            <div class="d-flex align-items-center">
                <form method="post" class="d-flex align-items-center js-basket-quantity-form" onSubmit={e => e.preventDefault()}>
                    <label class="md-plus-hidden font-weight-bold mb-0 mr-3 mr-md-0" htmlFor={'basket_item_' + sku}>
                        Quantity:
                    </label>
                    <input
                        type="number"
                        class="basket__quantity_input js-basket-quantity-input form-control text-xs"
                        defaultValue={quantity.toString(10)}
                        min="0"
                        max="999"
                        step={multiple ?? 1}
                        name="quantity"
                        id={'basket_item_' + sku}
                        disabled={isProcessing}
                        onInput={debounce(evt => {
                            const value = (evt.target as HTMLInputElement).value;
                            if (value === '') {
                                return;
                            }
                            const quantity = parseInt(value, 10);
                            if (
                                isNaN(quantity) ||
                                quantity < 0 ||
                                quantity > 999
                            ) {
                                return;
                            }
                            onUpdateQuantity(quantity);
                        }, 600)}
                    />
                </form>
                <form method="post" class="js-basket-remove-form" onSubmit={e => e.preventDefault()}>
                    <button type="button" class="basket__remove_btn btn" onClick={onRemove} disabled={isProcessing}>
                        <i aria-hidden="true" class="ev-icon ev-icon-remove"></i>
                        <span class="sr-only">Remove</span>
                    </button>
                </form>
            </div>
        </td>
        <td class="basket__total border-1 border-lg-left border-lg-right border-bottom">
            <Currency amount={subtotal} />
        </td>
    </tr>;
};

interface BasketTableRowProps {
    sku: string;
    productName: string;
    url: string;
    size: string;
    colour: string;
    quantity: number;
    unitPrice: string;
    tax: string;
    subtotal: string;
    total: string;
    error: string | null;
    warning: string | null;
    multiple: number | null;
    isProcessing: boolean;
    onRemove: () => void;
    onUpdateQuantity: (quantity: number) => void;
}

export default BasketTableRow;
